export enum ScoringTypes {
  percent,
  custom,
}
export enum TimeDecayDuration {
  month,
  halfDay,
}
